import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from '@/i18n/client';
import { selectTicket } from '@/store/event-payment/event-payment.actions';
import { selectSelectedTickets } from '@/store/event-payment/event-payment.selectotrs';
import { WithLang } from '@/types/general/base';
import { TicketSelectOption } from '@/types/tickets';

interface Props {
    ticketOption: TicketSelectOption;
}

export default function TicketFormItem(props: WithLang<Props>) {
    const dispatch = useDispatch();
    const selectedTickets = useSelector(selectSelectedTickets);
    const ticketsQuantity = selectedTickets?.find((item) => item.tag === props.ticketOption.tag)?.quantity || 0;

    const { t: tPayments } = useTranslation(props.lang, 'payments');
    const { t: tCommon } = useTranslation(props.lang, 'common');

    return (
        <>
            <div className="flex justify-between border-b border-gray-200 px-6 py-2 last-of-type:border-none sm:px-0 sm:py-4">
                <div className="flex flex-1 flex-col justify-between gap-y-2">
                    <span className="text-xs text-opacity-80 sm:text-base">{tPayments('tickets.type')}</span>
                    <span className="text-sm sm:text-lg lg:text-lg">{props.ticketOption.tag}</span>
                </div>
                <div className="flex flex-1 flex-col justify-between gap-y-2">
                    <span className="text-xs text-opacity-80 sm:text-base">{tCommon('common.price')}</span>
                    <span className="text-sm sm:text-lg lg:text-lg">
                        {tCommon('price.regular', {
                            currency: props.ticketOption.currency_code,
                            context: props.ticketOption.price,
                        })}
                    </span>
                </div>
                <div className="flex flex-[.2] flex-col gap-y-2">
                    <span className="text-xs text-opacity-80 sm:text-base">{tCommon('common.quantity')}</span>
                    <div className="flex items-center justify-between gap-x-2 sm:gap-x-4">
                        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-accent">
                            <button
                                disabled={ticketsQuantity <= 0}
                                onClick={() => {
                                    dispatch(
                                        selectTicket({
                                            ticket: props.ticketOption,
                                            action: 'decrease',
                                        }),
                                    );
                                }}
                                className="flex h-full w-full items-center justify-center rounded-full disabled:bg-gray-300 lg:text-2xl"
                            >
                                -
                            </button>
                        </div>
                        {selectedTickets && (
                            <span className="min-w-[14px] text-sm sm:text-base">{ticketsQuantity}</span>
                        )}
                        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-accent">
                            <button
                                disabled={ticketsQuantity >= props.ticketOption.quantity}
                                onClick={() => {
                                    //todo increase function
                                    dispatch(
                                        selectTicket({
                                            ticket: props.ticketOption,
                                            action: 'increase',
                                        }),
                                    );
                                }}
                                className="flex h-full w-full items-center justify-center rounded-full disabled:bg-gray-300 lg:text-2xl"
                            >
                                +
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
